import React from "react";
import ReactDOM from "react-dom/client";
// import 'primereact/resources/themes/bootstrap4-dark-blue/theme.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "../src/assets/css/style.scss";

import { PrimeReactProvider } from "primereact/api";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./reduxToolkit/store";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
